let collectionsData = [
    {
        name: 'Precofo Coloro',
        image: require('./assets/images/collections/1.png'),
    },
    {
        name: 'porro',
        image: require('./assets/images/collections/2.png'),
    },
    {
        name: 'dolor',
        image: require('./assets/images/collections/3.png'),
    },
    {
        name: 'aliquam',
        image: require('./assets/images/collections/4.png'),
    },
    {
        name: 'sequi',
        image: require('./assets/images/collections/5.png'),
    },
    {
        name: 'animi',
        image: require('./assets/images/collections/6.png'),
    },
    {
        name: 'omnis',
        image: require('./assets/images/collections/7.png'),
    },
    {
        name: 'est',
        image: require('./assets/images/collections/8.png'),
    },
    {
        name: 'suscipit',
        image: require('./assets/images/collections/9.png'),
    },
    {
        name: 'volutpatibus',
        image: require('./assets/images/collections/10.png'),
    },
    {
        name: 'ispa',
        image: require('./assets/images/collections/11.png'),
    },
    {
        name: 'itaque',
        image: require('./assets/images/collections/12.png'),
    
    },
    {
        name: 'consectetur',
        image: require('./assets/images/collections/13.png'),
    },
    {
        name: 'quibusdam',
        image: require('./assets/images/collections/14.png'),
    },
    {
        name: 'cupiditate',
        image: require('./assets/images/collections/15.png'),
    },
    {
        name: 'aliquid',
        image: require('./assets/images/collections/16.png'),
    },
    {
        name: 'amet',
        image: require('./assets/images/collections/17.png'),
    },
    {
        name: 'itaque',
        image: require('./assets/images/collections/18.png'),
    },
    {
        name: 'odio',
        image: require('./assets/images/collections/19.png'),
    },
    {
        name: 'sint',
        image: require('./assets/images/collections/20.png'),
    },
    {
        name: 'possimus',
        image: require('./assets/images/collections/21.png'),
    },
    {
        name: 'non',
        image: require('./assets/images/collections/22.png'),
    },
    {
        name: 'deserunt',
        image: require('./assets/images/collections/23.png'),
    },
    {
        name: 'consequuntur',
        image: require('./assets/images/collections/24.png'),
    },

    {
        name: 'itaque',
        image: require('./assets/images/collections/25.png'),
    },
    {
        name: 'aliquid',
        image: require('./assets/images/collections/16.png'),
    },
    {
        name: 'amet',
        image: require('./assets/images/collections/17.png'),
    },
    {
        name: 'itaque',
        image: require('./assets/images/collections/18.png'),
    },
    {
        name: 'odio',
        image: require('./assets/images/collections/19.png'),
    },
    {
        name: 'sint',
        image: require('./assets/images/collections/20.png'),
    },
    {
        name: 'possimus',
        image: require('./assets/images/collections/21.png'),
    },
    {
        name: 'non',
        image: require('./assets/images/collections/22.png'),
    },
    {
        name: 'deserunt',
        image: require('./assets/images/collections/23.png'),
    },
    {
        name: 'consequuntur',
        image: require('./assets/images/collections/24.png'),
    },
    {
        name: 'itaque',
        image: require('./assets/images/collections/25.png'),
    },
]

let collectionsData2 = [
    {
        name: 'Precofo Coloro',
        image: 'https://media.giphy.com/media/E3y79zUo2V4v8AFG2V/giphy.gif',
    },
    {
        name: 'porro',
        image: 'https://images.unsplash.com/photo-1464820453369-31d2c0b651af?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'dolor',
        image: 'https://media0.giphy.com/media/ho0xXatV7b3Fo1ZRXN/giphy.gif?cid=790b7611f70df0baee28b9995f736233369b48130d634f60&rid=giphy.gif&ct=g',
    },
    {
        name: 'aliquam',
        image: 'https://images.unsplash.com/photo-1527275393322-8ddae8bd5de9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'sequi',
        image: 'https://images.unsplash.com/photo-1526047932273-341f2a7631f9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'animi',
        image: 'https://images.unsplash.com/photo-1518732836484-bd257665c9d1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'omnis',
        image: 'https://media.giphy.com/media/IiuZjA4RQUKIf5TbMi/giphy-downsized-large.gif',
    },
    {
        name: 'est',
        image: 'https://images.unsplash.com/photo-1515405295579-ba7b45403062?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'suscipit',
        image: 'https://media.giphy.com/media/xTiTnumdcQABBLgM92/giphy.gif',
    },
    {
        name: 'volutpatibus',
        image: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'ispa',
        image: 'https://images.unsplash.com/photo-1558865869-c93f6f8482af?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=881&q=80',
    },
    {
        name: 'itaque',
        image: 'https://images.unsplash.com/photo-1531489956451-20957fab52f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    
    },
    {
        name: 'consectetur',
        image: 'https://media4.giphy.com/media/rth8I5FQNiB86Gs2Kd/giphy.gif?cid=790b7611f57eaa435a6f2fbdd446525f740671b8a52428af&rid=giphy.gif&ct=g',
    },
    {
        name: 'quibusdam',
        image: 'https://media.giphy.com/media/xTiTnumdcQABBLgM92/giphy.gif',
    },
    {
        name: 'cupiditate',
        image: 'https://images.unsplash.com/photo-1577138043155-7934dd897541?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'aliquid',
        image: 'https://images.unsplash.com/photo-1574169208507-84376144848b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=879&q=80',
    },
    {
        name: 'odio',
        image: 'https://images.unsplash.com/photo-1548858819-650032a07cf0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'amet',
        image: 'https://images.unsplash.com/photo-1601318314960-e17a48ebb6f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'itaque',
        image: 'https://images.unsplash.com/photo-1531489956451-20957fab52f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    
    },
    {
        name: 'sint',
        image: 'https://images.unsplash.com/photo-1586602057338-9d509437c255?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'possimus',
        image: 'https://images.unsplash.com/photo-1535083988052-565ca9546643?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'non',
        image: 'https://images.unsplash.com/photo-1585683936597-63d313c21a87?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'deserunt',
        image: 'https://images.unsplash.com/photo-1583084578896-19b9c8f68fe7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'consequuntur',
        image: 'https://images.unsplash.com/photo-1621075161884-97917b7782f7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },

    {
        name: 'itaque',
        image: 'https://images.unsplash.com/photo-1614183907279-4c5c1640ed77?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=868&q=80',
    },
    {
        name: 'aliquid',
        image: 'https://images.unsplash.com/photo-1594694899408-32443deff59f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'amet',
        image: 'https://images.unsplash.com/photo-1606179026380-6eb739177496?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'itaque',
        image: 'https://images.unsplash.com/photo-1531489956451-20957fab52f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    
    },
    {
        name: 'sint',
        image: 'https://images.unsplash.com/photo-1586602057338-9d509437c255?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'possimus',
        image: 'https://images.unsplash.com/photo-1535083988052-565ca9546643?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'non',
        image: 'https://images.unsplash.com/photo-1585683936597-63d313c21a87?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'deserunt',
        image: 'https://images.unsplash.com/photo-1583084578896-19b9c8f68fe7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
    {
        name: 'consequuntur',
        image: 'https://images.unsplash.com/photo-1615195627275-48660e9cd84f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
    },
  
]

let items = [
    {
        collection: 'Solana Monkey Business',
        name: 'SMB #2770',
        owner: 'C02Xaj4D414mqrj41E21IIQ9Ann7',
        attribute_count: '3',
        attribute_count_percentage: '38.9%',
        type: 'Brown',
        type_percentage: '28.4%',
        clothes: 'Brown Jacket',
        clothes_percentage: '7.2%',
        about: 'SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.',
        image: 'https://images.unsplash.com/photo-1569437061238-3cf61084f487?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80',
        accountDetails:{
            mint_address: '4x023230230iuo',
            token_address: '2xaSe232202210',
            owner: '5x1c21120221k0',
            artist_royalities: '2%',
            transaction_fee: '0.01%',
        },
        offers: {
            price: '$1.00',
            expiration: '2020-01-01',
            from: '5x1c21120221k0',
        },
        tradingHistory: {
            event: 'offer',
            item: 'SMB #2770',
            price: '$1.00',
            from : '5x1c21120221k0',
            to: '4x023230230iuo',
            date: '2020-01-01',
        }
    },
    {
        collection: 'Solana Monkey Business',
        name: 'SMB #2770',
        owner: 'C02Xaj4D414mqrj41E21IIQ9Ann7',
        attribute_count: '3',
        attribute_count_percentage: '38.9%',
        type: 'Brown',
        type_percentage: '28.4%',
        clothes: 'Brown Jacket',
        clothes_percentage: '7.2%',
        about: 'SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.',
        image: 'https://images.unsplash.com/photo-1547826039-bfc35e0f1ea8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1072&q=80',
        accountDetails:{
            mint_address: '4x023230230iuo',
            token_address: '2xaSe232202210',
            owner: '5x1c21120221k0',
            artist_royalities: '2%',
            transaction_fee: '0.01%',
        },
        offers: {
            price: '$1.00',
            expiration: '2020-01-01',
            from: '5x1c21120221k0',
        },
        tradingHistory: {
            event: 'offer',
            item: 'SMB #2770',
            price: '$1.00',
            from : '5x1c21120221k0',
            to: '4x023230230iuo',
            date: '2020-01-01',
        }
    },
    {
        collection: 'Solana Monkey Business',
        name: 'SMB #2770',
        owner: 'C02Xaj4D414mqrj41E21IIQ9Ann7',
        attribute_count: '3',
        attribute_count_percentage: '38.9%',
        type: 'Brown',
        type_percentage: '28.4%',
        clothes: 'Brown Jacket',
        clothes_percentage: '7.2%',
        about: 'SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.',
        image: 'https://images.unsplash.com/photo-1482160549825-59d1b23cb208?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80',
        accountDetails:{
            mint_address: '4x023230230iuo',
            token_address: '2xaSe232202210',
            owner: '5x1c21120221k0',
            artist_royalities: '2%',
            transaction_fee: '0.01%',
        },
        offers: {
            price: '$1.00',
            expiration: '2020-01-01',
            from: '5x1c21120221k0',
        },
        tradingHistory: {
            event: 'offer',
            item: 'SMB #2770',
            price: '$1.00',
            from : '5x1c21120221k0',
            to: '4x023230230iuo',
            date: '2020-01-01',
        }
    },
    {
        collection: 'Solana Monkey Business',
        name: 'SMB #2770',
        owner: 'C02Xaj4D414mqrj41E21IIQ9Ann7',
        attribute_count: '3',
        attribute_count_percentage: '38.9%',
        type: 'Brown',
        type_percentage: '28.4%',
        clothes: 'Brown Jacket',
        clothes_percentage: '7.2%',
        about: 'SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.',
        image: 'https://images.unsplash.com/photo-1570393080660-de4e4a15a247?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
        accountDetails:{
            mint_address: '4x023230230iuo',
            token_address: '2xaSe232202210',
            owner: '5x1c21120221k0',
            artist_royalities: '2%',
            transaction_fee: '0.01%',
        },
        offers: {
            price: '$1.00',
            expiration: '2020-01-01',
            from: '5x1c21120221k0',
        },
        tradingHistory: {
            event: 'offer',
            item: 'SMB #2770',
            price: '$1.00',
            from : '5x1c21120221k0',
            to: '4x023230230iuo',
            date: '2020-01-01',
        }
    },
    {
        collection: 'Solana Monkey Business',
        name: 'SMB #2770',
        owner: 'C02Xaj4D414mqrj41E21IIQ9Ann7',
        attribute_count: '3',
        attribute_count_percentage: '38.9%',
        type: 'Brown',
        type_percentage: '28.4%',
        clothes: 'Brown Jacket',
        clothes_percentage: '7.2%',
        about: 'SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.',
        image: 'https://images.unsplash.com/photo-1541367777708-7905fe3296c0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1495&q=80',
        accountDetails:{
            mint_address: '4x023230230iuo',
            token_address: '2xaSe232202210',
            owner: '5x1c21120221k0',
            artist_royalities: '2%',
            transaction_fee: '0.01%',
        },
        offers: {
            price: '$1.00',
            expiration: '2020-01-01',
            from: '5x1c21120221k0',
        },
        tradingHistory: {
            event: 'offer',
            item: 'SMB #2770',
            price: '$1.00',
            from : '5x1c21120221k0',
            to: '4x023230230iuo',
            date: '2020-01-01',
        }
    },
    {
        collection: 'Solana Monkey Business',
        name: 'SMB #2770',
        owner: 'C02Xaj4D414mqrj41E21IIQ9Ann7',
        attribute_count: '3',
        attribute_count_percentage: '38.9%',
        type: 'Brown',
        type_percentage: '28.4%',
        clothes: 'Brown Jacket',
        clothes_percentage: '7.2%',
        about: 'SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.',
        image: 'https://images.unsplash.com/photo-1558865869-c93f6f8482af?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=881&q=80',
        accountDetails:{
            mint_address: '4x023230230iuo',
            token_address: '2xaSe232202210',
            owner: '5x1c21120221k0',
            artist_royalities: '2%',
            transaction_fee: '0.01%',
        },
        offers: {
            price: '$1.00',
            expiration: '2020-01-01',
            from: '5x1c21120221k0',
        },
        tradingHistory: {
            event: 'offer',
            item: 'SMB #2770',
            price: '$1.00',
            from : '5x1c21120221k0',
            to: '4x023230230iuo',
            date: '2020-01-01',
        }
    },
    {
        collection: 'Solana Monkey Business',
        name: 'SMB #2770',
        owner: 'C02Xaj4D414mqrj41E21IIQ9Ann7',
        attribute_count: '3',
        attribute_count_percentage: '38.9%',
        type: 'Brown',
        type_percentage: '28.4%',
        clothes: 'Brown Jacket',
        clothes_percentage: '7.2%',
        about: 'SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.',
        image: 'https://images.unsplash.com/photo-1594476664296-8c552053aef3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        accountDetails:{
            mint_address: '4x023230230iuo',
            token_address: '2xaSe232202210',
            owner: '5x1c21120221k0',
            artist_royalities: '2%',
            transaction_fee: '0.01%',
        },
        offers: {
            price: '$1.00',
            expiration: '2020-01-01',
            from: '5x1c21120221k0',
        },
        tradingHistory: {
            event: 'offer',
            item: 'SMB #2770',
            price: '$1.00',
            from : '5x1c21120221k0',
            to: '4x023230230iuo',
            date: '2020-01-01',
        }
    },
    {
        collection: 'Solana Monkey Business',
        name: 'SMB #2770',
        owner: 'C02Xaj4D414mqrj41E21IIQ9Ann7',
        attribute_count: '3',
        attribute_count_percentage: '38.9%',
        type: 'Brown',
        type_percentage: '28.4%',
        clothes: 'Brown Jacket',
        clothes_percentage: '7.2%',
        about: 'SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.',
        image: 'https://images.unsplash.com/photo-1610925699730-6ee9612c557c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
        accountDetails:{
            mint_address: '4x023230230iuo',
            token_address: '2xaSe232202210',
            owner: '5x1c21120221k0',
            artist_royalities: '2%',
            transaction_fee: '0.01%',
        },
        offers: {
            price: '$1.00',
            expiration: '2020-01-01',
            from: '5x1c21120221k0',
        },
        tradingHistory: {
            event: 'offer',
            item: 'SMB #2770',
            price: '$1.00',
            from : '5x1c21120221k0',
            to: '4x023230230iuo',
            date: '2020-01-01',
        }
    },
    {
        collection: 'Solana Monkey Business',
        name: 'SMB #2770',
        owner: 'C02Xaj4D414mqrj41E21IIQ9Ann7',
        attribute_count: '3',
        attribute_count_percentage: '38.9%',
        type: 'Brown',
        type_percentage: '28.4%',
        clothes: 'Brown Jacket',
        clothes_percentage: '7.2%',
        about: 'SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.',
        image: 'https://images.unsplash.com/photo-1550056486-8ded219fb769?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        accountDetails:{
            mint_address: '4x023230230iuo',
            token_address: '2xaSe232202210',
            owner: '5x1c21120221k0',
            artist_royalities: '2%',
            transaction_fee: '0.01%',
        },
        offers: {
            price: '$1.00',
            expiration: '2020-01-01',
            from: '5x1c21120221k0',
        },
        tradingHistory: {
            event: 'offer',
            item: 'SMB #2770',
            price: '$1.00',
            from : '5x1c21120221k0',
            to: '4x023230230iuo',
            date: '2020-01-01',
        }
 
    },
]

let rankingStats = [
    {
        "id": 1,
        "title": "SMB #2770",
        "image": 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",
    },
    {
        "id": 2,
        "title": "Prefocco Coloro",
        "image": 'https://images.unsplash.com/photo-1558865869-c93f6f8482af?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=881&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",

    },
    {
        "id": 3,
        "title": "Porro",
        "image": 'https://images.unsplash.com/photo-1601318314960-e17a48ebb6f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",

    },
    {
        "id": 4,
        "title": "Dolor",
        "image": 'https://images.unsplash.com/photo-1531489956451-20957fab52f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2080&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",

    },
    {
        "id": 5,
        "title": "Aliquim",
        "image": 'https://images.unsplash.com/photo-1533644756484-bb7b29ac7fcd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",

    },
    {
        "id": 6,
        "title": "Siqui",
        "image": 'https://images.unsplash.com/photo-1596120718374-028fba035262?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=882&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",

    },
    {
        "id": 7,
        "title": "Animi",
        "image": 'https://images.unsplash.com/photo-1555580168-9fb9646a8a1b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",

    },
    {
        "id": 8,
        "title": "Consectetor",
        "image": 'https://images.unsplash.com/photo-1518640467707-6811f4a6ab73?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",

    },
    {
        "id": 9,
        "title": "Itaque",
        "image": 'https://images.unsplash.com/photo-1552765593-e48b46abe866?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=862&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",
    },
    {
        "id": 10,
        "title": "Omnis",
        "image": 'https://images.unsplash.com/photo-1617939254715-cce00563cbc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "volume": "27,00.88",
        "percent7h": "-28.94%",
        "percent24h": "+28.94%",
        "floorPrice": "10.3",
        "owners": "5.2k",
        "items": "11.5k",

    }
    
];

let activityStats = [
    {
        "id": 1,
        "title": "SMB #2770",
        "image": 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",
    },
    {
        "id": 2,
        "title": "Prefocco Coloro",
        "image": 'https://images.unsplash.com/photo-1558865869-c93f6f8482af?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=881&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",

    },
    {
        "id": 3,
        "title": "Porro",
        "image": 'https://images.unsplash.com/photo-1601318314960-e17a48ebb6f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",

    },
    {
        "id": 4,
        "title": "Dolor",
        "image": 'https://images.unsplash.com/photo-1531489956451-20957fab52f2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2080&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",

    },
    {
        "id": 5,
        "title": "Aliquim",
        "image": 'https://images.unsplash.com/photo-1533644756484-bb7b29ac7fcd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",

    },
    {
        "id": 6,
        "title": "Siqui",
        "image": 'https://images.unsplash.com/photo-1596120718374-028fba035262?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=882&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",

    },
    {
        "id": 7,
        "title": "Animi",
        "image": 'https://images.unsplash.com/photo-1555580168-9fb9646a8a1b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",
    },
    {
        "id": 8,
        "title": "Consectetor",
        "image": 'https://images.unsplash.com/photo-1518640467707-6811f4a6ab73?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",

    },
    {
        "id": 9,
        "title": "Itaque",
        "image": 'https://images.unsplash.com/photo-1552765593-e48b46abe866?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=862&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",
    },
    {
        "id": 10,
        "title": "Omnis",
        "image": 'https://images.unsplash.com/photo-1617939254715-cce00563cbc3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        "description": "Activity Stat Description",
        "ethprice": "0.11",
        "usdprice": "0.566",
        "quantity": "2",
        "from": "4xF21csQ",
        "to": "LswxYssf",
        "time": "30s",
    }
    
]

let auctions = [
    {
        title: 'Origin of Steel',
        createdBy: '4xF21csQ',
        description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying ...',
        image: 'https://media.giphy.com/media/WqEB0r0gy7hOnAcBnh/giphy.gif',
    },
    {
        title: 'Origin of Water',
        createdBy: '4xF21csQ',
        description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying ...',
        image: 'https://media.giphy.com/media/26tn6t51nYZDwNIqI/giphy.gif',
    },
    {
        title: 'Origin of Fire',
        createdBy: '4xF21csQ',
        description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying ...',
        image: 'https://media.giphy.com/media/13ZOPnlbZJQd8c/giphy.gif',
    },
    {
        title: 'Origin of Earth',
        createdBy: '4xF21csQ',
        description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying ...',
        image: 'https://media.giphy.com/media/E8XiDoLZCly6I/giphy.gif',
    },
    {
        title: 'Origin of Land',
        createdBy: '4xF21csQ',
        description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying ...',
        image: 'https://media.giphy.com/media/xT1XGTaTeovBeLdrRS/giphy.gif',
    },
    {
        title: 'Origin of Air',
        createdBy: '4xF21csQ',
        description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying ...',
        image: 'https://media.giphy.com/media/3oxRmyMA9sMiXjEaZ2/giphy.gif',
    },
    {
        title: 'Origin of Life',
        createdBy: '4xF21csQ',
        description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying ...',
        image: 'https://media.giphy.com/media/smUVP59AQXf0s/giphy.gif',
    },
    {
        title: 'Origin of Death',
        createdBy: '4xF21csQ',
        description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying ...',
        image: 'https://media.giphy.com/media/3o6Zth6ESVf6i9X8e4/giphy-downsized-large.gif',
    },
    {
        title: 'Origin of Time',
        createdBy: '4xF21csQ',
        description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying ...',
        image: 'https://media.giphy.com/media/xT1XGTaTeovBeLdrRS/giphy.gif',
    },
]
export {items, collectionsData, rankingStats, activityStats, auctions};
export default collectionsData2;

